<template >
  <div>
    <!-- style="height: 400px;" -->
    <div>
      <b-carousel
        id="banners"
        v-model="slide"
        :interval="4000"
        indicators
        img-height="400"
        class="d-block img-fluid w-100"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <a v-for="(slide, index) of dataSlider" :key="index" :href="slide.href" target="_blank">
          <b-carousel-slide :img-src="slide.img_src" class="img-banner-carga">
            <div class="text-left content-slider">
              <!-- <span class="titulo">{{ slide.titulo }}</span> -->
              <br />
              <span class="titulo" v-if="slide.subtitulo != null">{{
                slide.subtitulo
              }}</span>
              <br />
              <p class="text-justify">{{ slide.text }}</p>
              <b-button v-if="slide.boton == true" variant="outline-primary">
                {{ slide.texto_boton }}
              </b-button>
            </div>
          </b-carousel-slide>
        </a>
      </b-carousel>
    </div>

    <p></p>
    <b-container
      fluid
      class="mb-4 mt-5 text-center"
      style="background-color: white !important"
    >
      <div class="titulo-acceso">
        <b-row align-v="center">
          <b-col cols="4" lg="2" align-self="center" class="acc">
            <!-- <hr class="linea-vertical"> -->
            <h3 class="color-primary">Acceso Directo</h3>
            <hr class="linea linea-acceso" />
            <p v-if="$store.state.user.user" class="color-primary"> Último acceso : {{ utimo_accesso }}</p>
          </b-col>
          <b-col
            cols="4"
            lg
            v-for="(acceso, index) of accesosVisibles"
            :key="index"
            class="col-acceso"
          >
            <a v-if="!acceso.disabled" :href="acceso.to" class="linkAcceso">
              <b-row align-v="center">
                <b-col cols="12" align-self="center">
                  <img :src="acceso.src" class="imgacce" />
                </b-col>
                <b-col cols="12" align-self="center">
                  <div class="text-center texto mt-2 mb-2">
                    {{ acceso.texto }}
                  </div>
                </b-col>
              </b-row>
            </a>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

import accesosDirectos from "@/data/AccesosDirectosHome.json";

export default {
  name: "Home",
  computed: {
    ...mapGetters({
      dataSlider: "pages/dataSlider",
    }),
    // Los accesos con "permiso" solo se muestran si el usuario tiene ese módulo del portal
    accesosVisibles() {
      const permisos = this.$store.state.user.permisos || [];
      return this.accesosDirectos.filter(
        (acceso) => !acceso.permiso || permisos.some((p) => p.descripcion === acceso.permiso)
      );
    },
  },
  data() {
    return {
      accesosDirectos: accesosDirectos,
      slide: 0,
      sliding: null,
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    index(page = 1, paginar = true) {
      this.$store.dispatch("pages/fetchBanner", {
        endpoint: "informes/banners",
        params: {},
      });
    },
  },
  mounted() {
    this.utimo_accesso = this.$store.state.user.user ? this.$store.state.user.user.fecha_ultimo_inicio : "";
    this.index();
    this.$store.dispatch("user/me", { endpoint: "user/me" });
    this.$store.dispatch("pages/fetchTitulosFacturacion", {
      endpoint: "configuracion/label_facturacion_portal",
      params: {
        paginar: "false",
      },
    });
  },
};
</script>
